import axios from "axios";
import { environment } from "./environment";
const instance = axios.create({
  baseURL: environment.baseURL,
  headers: {
    "Content-Type": "application/json",
  }
});
export default instance;
